const _temp0 = require("../auto-height/auto-height-script.js");

const _temp1 = require("../animation-disabler/animation-disabler-script.js");

const _temp2 = require("../background-attachment-fixed/background-attachment-fixed-script.js");

const _temp3 = require("../menu/menu-script.js");

const _temp4 = require("../tabs/tabs-script.js");

const _temp5 = require("../toggle/toggle-script.js");

module.exports = {
  "auto-height":   {
    "auto-height-": _temp0
  },
  "animation-disabler":   {
    "animation-disabler-": _temp1
  },
  "background-attachment-fixed":   {
    "background-attachment-fixed-": _temp2
  },
  "menu":   {
    "menu-": _temp3
  },
  "tabs":   {
    "tabs-": _temp4
  },
  "toggle":   {
    "toggle-": _temp5
  }
}